import { HEADER_TITLE_UPDATE } from '../../action-types';

//更新Header区域显示的菜单信息
export const updateHeaderTitle = (title) => {
  // console.log('updateHeaderTitle', title);
  return (dispatch) => {
    dispatch({
      type: HEADER_TITLE_UPDATE,
      payload: title,
    });
  };
};
